const Section = ({ title, rows }) => (
  <div className="card shadow-sm mb-3">
    <div className="card-header fw-bold text-white py-2 px-3" style={{ background: "#90b732", fontSize: "13px" }}>
      <i className="bi bi-info-circle me-2"></i>{title}
    </div>
    <div className="card-body p-0">
      <table className="table table-sm mb-0" style={{ fontSize: "13px" }}>
        <tbody>
          {rows.map(([label, value], i) => (
            <tr key={i} className={i % 2 === 0 ? "table-light" : ""}>
              <td className="fw-semibold text-muted ps-3 py-2" style={{ width: "220px", whiteSpace: "nowrap" }}>{label}</td>
              <td className="py-2 text-muted">:</td>
              <td className="fw-semibold py-2 pe-3">{value || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

const Profile = () => (
  <div className="container-fluid mt-2 px-3" style={{ maxWidth: "860px" }}>
    <h6 className="fw-bold mb-3 pb-2" style={{ borderBottom: "2px solid #90b732", color: "#90b732" }}>
      <i className="bi bi-person-badge me-2"></i>Partner Profile Details
    </h6>

    <Section title="Basic Details" rows={[
      ["Partner Name",           "Shrikant Tally Institute (TAC)"],
      ["Admin Email ID",         "shrikanttallyinstitute@gmail.com"],
      ["Serial Number",          "758796246"],
      ["Year of Establishment",  "2022"],
      ["Institute Type",         "Proprietorship"],
      ["Place Type",             "Rented"],
      ["Parent MTAP",            "Laxmi Education"],
      ["Number of PCs",          "16"],
      ["Status",                 <span className="badge bg-success">Active</span>],
      ["Empanelment Expiry",     "16-10-2025"],
    ]} />

    <Section title="Address Details" rows={[
      ["Address",      "Puran Thana Asati ward no-1, Nearby SBI ATM"],
      ["City",         "Damoh"],
      ["State",        "Madhya Pradesh"],
      ["Country",      "India"],
      ["Postal Code",  "470661"],
      ["Landline",     "9131385180"],
    ]} />

    <Section title="Contact Person" rows={[
      ["Name",    "Shrikant Jain"],
      ["Email",   "shrikanttallyinstitute@gmail.com"],
      ["Mobile",  "9131385180"],
    ]} />

    <Section title="Statutory Details" rows={[
      ["Beneficiary Name",  "Shrikant Jain"],
      ["Account Number",    "946010110011408"],
      ["IFSC Code",         "BKID0009460"],
      ["Bank Name",         "Bank Of India"],
      ["Bank Branch",       "Damoh"],
      ["PAN Number",        "AYTPJ7302D"],
      ["GSTIN",             "—"],
      ["MSME Registered",   "No"],
    ]} />

    <div className="card shadow-sm mb-3">
      <div className="card-header fw-bold text-white py-2 px-3" style={{ background: "#90b732", fontSize: "13px" }}>
        <i className="bi bi-gift me-2"></i>Benefit Details
      </div>
      <div className="card-body p-0">
        <table className="table table-sm table-hover mb-0" style={{ fontSize: "13px" }}>
          <thead style={{ background: "#f4fce8" }}>
            <tr>
              <th className="ps-3">#</th>
              <th>Benefit</th>
              <th>Last Provided Date</th>
            </tr>
          </thead>
          <tbody>
            <tr><td className="ps-3">1</td><td>Academic Counselor Training - Offline</td><td>—</td></tr>
            <tr><td className="ps-3">2</td><td>Initial TTT - Offline and Online (Free)</td><td>—</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default Profile;
